import { memo } from 'react'

const FCPrivacyPage = () => <div>2</div>

export const PrivacyPage = memo(FCPrivacyPage)
